import { toast } from "react-toastify";
import { LIST_ALL_USERS, BLOCK_USER_API } from "../../../helper/url_helper";
import { axiosApi } from "../../../services/api";

import { createAsyncThunk } from "@reduxjs/toolkit";

// export const handleUsers = createAsyncThunk(
//   "users/handleUsers",
//   async (request) => {
//     try {
//       const res = await axiosApi.get(GET_ALL_MY_FRIENDS, request);
//       return res?.data?.data;
//     } catch (err) {
//       return {
//         error: err?.response?.data?.error,
//         statusCode: err.response?.status || 500,
//       };
//     }
//   }
// );

export const getAllUsers = createAsyncThunk(
  "users/getAllUsers",
  async (params, { rejectWithValue }) => {
    try {
      const res = await axiosApi.get(LIST_ALL_USERS, { params });
      // return {
      //   list: res.data.data.users,
      //   count: res.data.data.pagination.total,
      // };
      return res.data;

    } catch (err) {
      return rejectWithValue({
        message: err?.response?.data?.message,
        statusCode: err?.response?.status,
      });

    }
  }
);
export const handleBlockUser = createAsyncThunk(
  "users/handleBlockUser",
  async ({ userId, status }, { rejectWithValue }) => {
    try {
      // Determine action based on current status
      const action = status === "BLOCKED" ? "unblock" : "block";

      const res = await axiosApi.patch(BLOCK_USER_API(userId), { action });
      if (res?.data?.success) {
        toast.success(res?.data?.message || "User Status Updated");
        return { userId, action };
      }
      return rejectWithValue(res?.data?.message || "Failed to update status");

    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.error || "Something went wrong"
      );
    }
  }
);